const actionTypeIdentifier = "7C0E9E01-C603-4C9D-9750-645DD99888CC";

export const getCircuitAccessInformationDetails = `GET-CIRCUIT-ACCESS-INFORMATION-DETAILS-${actionTypeIdentifier}`;

export const accessInformationFormModel = {
    siteSurveyRequested: null,
    accessBandwidth: null,
    access: null,
    existingCircuitID: null,
    isCoordinatedService: null,
    electricalOpticalInterface: null,
    requiredLOACFA: null,
    accessPortCIR: null,
    DLCI: null,
    serviceClass: null,
    uploadSpeed: null,
    downloadSpeed: null,
    requestedIP: null,
    handsOffType: null
};